module.exports = __webpack_public_path__ + "img/QW4104x6PD.fc280687.jpg";